import React, { useEffect } from 'react'
import scrollToTop from '../helpers/scrollToTop'
import bannerImage from '../images/banner-image.jpg'

function Terms() {
  useEffect(() => {
    scrollToTop()
  },[])
  
  return (
    <div className='min-h-screen bg-[#F5F1E9]'>
      {/* Content Section */}
      <div className='max-w-6xl mx-auto px-4 py-12'>
        <h1 className='text-2xl md:text-3xl lg:text-4xl font-light tracking-wide  mb-8'>
            Termos de Serviço
        </h1>

        <p className='text-gray-700 mb-4 italic'>
            Ultima atualização: 16 de Setembro de 2025
        </p>
        <p className='text-gray-700 mb-8'>
            Estes Termos regulam a utilização do nosso sistema de reservas online.
        </p>

        <h3 className='text-lg md:text-2xl lg:text-3xl font-light tracking-wide mb-4'>
            1. Serviço Prestado
        </h3>
        <p className='text-gray-700 mb-8'>
            A nossa plataforma permite aos utilizadores marcar serviços com profissionais<br/>
            Ao efetuar uma reserva, concorda em fornecer informações verdadeiras e corretas
        </p>

        <h3 className='text-lg md:text-2xl lg:text-3xl font-light tracking-wide mb-4'>
            2. Responsabilidades do Utilizador
        </h3>
        <p className='text-gray-700'>
            Ao utilizar o nosso sistema de reservas, concorda que:
        </p>
        <ul className='list-disc list-inside text-gray-700 mb-8'>
            <li>Deve fornecer um número de telemóvel válido para que as profissionais possam confirmar ou entrar em contacto relativamente à sua marcação</li>
            <li>O fornecimento de um email é opcional, mas pode ajudar na identificação da sua reserva</li>
            <li>Compromete-se a comparecer à marcação ou a cancelá-la atempadamente se não puder comparecer</li>
        </ul>
        
        <h3 className='text-lg md:text-2xl lg:text-3xl font-light tracking-wide mb-4'>
            3. Lembretes de Marcação
        </h3>
        <p className='text-gray-700 mb-8'>
            Podemos enviar lembretes por SMS para o contacto fornecido relativamente às suas marcações
        </p>


        <h3 className='text-lg md:text-2xl lg:text-3xl font-light tracking-wide mb-4'>
            4. Cancelamentos e Alterações
        </h3>
        <p className='text-gray-700 mb-8'>
            Os cancelamentos devem ser efetuados com pelo menos 24 horas de antecedência <br/>
            As profissionais reservam o direito de reagendar ou cancelar marcações em caso de imprevistos, informando o cliente atempadamente
        </p>

        <h3 className='text-lg md:text-2xl lg:text-3xl font-light tracking-wide mb-4'>
            5. Limitação de Responsabilidade
        </h3>
        <p className='text-gray-700 mb-8'>
            Procuramos manter o sistema de reservas disponível e preciso, mas não podemos garantir serviço ininterrupto <br/>
            As profissionais não são responsáveis por danos indiretos ou consequenciais relacionados com a utilização da plataforma
        </p>

        <h3 className='text-lg md:text-2xl lg:text-3xl font-light tracking-wide mb-4'>
            6. Privacidade
        </h3>
        <p className='text-gray-700 mb-8'>
            Os seus dados pessoais são tratados em conformidade com a nossa <a href="/privacy" className="text-blue-600 underline">Política de Privacidade</a>
        </p>

        <h3 className='text-lg md:text-2xl lg:text-3xl font-light tracking-wide mb-4'>
            7. Alterações aos Termos
        </h3>
        <p className='text-gray-700 mb-8'>
            Reservamo-nos o direito de alterar estes Termos a qualquer momento <br/>
            As versões atualizadas serão publicadas nesta página com a respetiva data de atualização
        </p>
      </div>  
    </div>
  )
}

export default Terms